import http from './httpService';
import customHttp from './httpCustom';
import { decodeToken } from 'utils';

export const districtService = () => {
  return http.get('/api/check/rwanda');
};

export const houseCategoryService = () => {
  return http.get('/api/house-categories');
};

export const houseRangeService = (data) => {
  return http.post('/api/house-ranges', data);
};

export const bankService = () => {
  return http.get('/api/banks');
};

export const applicationService = (data) => {
  return http.post('/api/loan/application', data);
};

export const upiService = (data) => {
  return http.post('/api/check/upis', data);
};

export const loanService = (data) => {
  return http.post('/api/check/loanBreakdown', data);
};

export const myLoanService = () => {
  return http.get('/api/loan');
};

export const loanApplicationService = (data) => {
  return http.post('api/loan/', data);
};

export const bankStatsService = (bank) => {
  return http.get(`api/loan/${bank}/stats`);
};

export const specificLoanApplicationService = (id) => {
  return http.get(`api/loan/${id}`);
};

export const downloadService = (id, genre, certificateType) => {
  return http.get(`api/loan/${id}/certificate/${genre}.${certificateType}`);
};

export const zipDownloadService = (id) => {
  return http.get(`api/loan/${id}/certificates`);
};

export const changeApplicationStatus = (id, action, level, payload) => {
  return customHttp.patch(`api/loan/${id}/${action}/${level}`, payload);
};

export const commentApplication = (id, user, payload) => {
  const role = decodeToken()?.userRole?.RoleName;
  let url;
  if (role !== 'Applicant') {
    url = `api/loan/${id}/document/${user}`;
  } else {
    url = `api/loan/document`;
  }
  return customHttp.post(url, payload);
};

export const downloadDocument = (applicationId, docId, user) => {
  return customHttp.get(
    `api/loan/${applicationId}/document/admin/doc/${docId}`
  );
};

export const downloadApplicantDocument = (docId) => {
  return customHttp.get(`/api/loan/document/doc/${docId}`);
};

export const downloadApplicantZipDocument = () => {
  return customHttp.get(`/api/loan/certificates`);
};
